// 导入组件
import simpleSearchBar from './src/simple-search-bar.vue'

// 为组件提供 install 安装方法，供按需引入
simpleSearchBar.install = function (Vue) {
  Vue.component(simpleSearchBar.name, simpleSearchBar)
}

// 默认导出组件
export default simpleSearchBar
